import { BrokerAvatar } from '@/components/Broker/BrokerAvatar'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import type { Broker } from '@/models/broker'
import { packageCarriers, type QuotePackage } from './PackageCard'

interface PackageAnnouncementDialogProps {
  quotePackage: QuotePackage
  broker: Broker | null
  open: boolean
  onDismiss: () => void
  onCheckItOut: () => void
}

/** Tells a customer, once, that their broker put a package on their quotes page. */
export function PackageAnnouncementDialog({
  quotePackage,
  broker,
  open,
  onDismiss,
  onCheckItOut,
}: PackageAnnouncementDialogProps) {
  const brokerFirstName = broker?.name.split(' ')[0] || undefined

  return (
    <Dialog open={open} onOpenChange={(next) => !next && onDismiss()}>
      <DialogContent size="sm" aria-describedby={undefined}>
        <div className="flex items-center justify-center gap-2">
          {packageCarriers(quotePackage).map((line) => (
            <img
              key={line.carrierName}
              src={line.iconUrl}
              alt={line.iconAlt}
              className="border-ink-100 bg-card size-12 rounded-full border object-contain"
            />
          ))}
          {broker && <BrokerAvatar broker={broker} />}
        </div>
        <DialogHeader>
          <DialogTitle className="text-ink text-center text-xl leading-relaxed font-normal">
            {brokerFirstName ?? 'Your matched broker'} has crafted a
            <br />
            <strong className="font-extrabold">recommended package</strong>
            <br />
            from your quotes!
          </DialogTitle>
        </DialogHeader>
        <DialogFooter className="sm:justify-center">
          <Button size="lg" onClick={onCheckItOut}>
            Check it out
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
